import _ from 'lodash'

export default {
  setAnimating: (state, which) => {
    state.animating = (_.isBoolean(which)) ? which : false
  },
  setSearchAnimating: (state, which) => {
    state.searchanimating = (_.isBoolean(which)) ? which : false
  },
  setLanguagesAnimating: (state, which) => {
    state.languagesanimating = (_.isBoolean(which)) ? which : false
  },
  toggleActive: (state, value) => {
    state.active = (_.isBoolean(value)) ? value : !state.active
  },
  toggleSearch: (state, value) => {
    state.searchactive = (_.isBoolean(value)) ? value : !state.searchactive
  },
  toggleLanguages: (state, value) => {
    state.languagesactive = (_.isBoolean(value)) ? value : !state.languagesactive
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/sidebar/mutations.js